export interface Pagination<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  first: boolean;
  last: boolean;
  size: number;
  number: number;
  numberOfElements: number;
  empty: boolean;
  sort: {
    empty: boolean;
    unsorted: boolean;
    sorted: boolean;
  };
  pageable: {
    offset: number;
    sort: {
      empty: boolean;
      unsorted: boolean;
      sorted: boolean;
    };
    unpaged: boolean;
    paged: boolean;
    pageNumber: number;
    pageSize: number;
  };
}

export class PaginationParams {
  search?: string = '';
  page: number = 0;
  size: number = 20;
  sort?: string = '';

  dateFrom?: string;
  dateTo?: string;
  status?: string | string[];

  constructor(data?: Partial<PaginationParams>) {
    this.search = data?.search ?? '';
    this.page = data?.page ?? 0;
    this.size = data?.size ?? 20;
    this.sort = data?.sort ?? '';
    this.dateFrom = data?.dateFrom;
    this.dateTo = data?.dateTo;
    this.status = data?.status;
  }
}
